import React from 'react';
import { Input, Button, Tooltip } from 'antd';
import { SendOutlined } from '@ant-design/icons';
import { useLanguage } from '../../contexts/LanguageContext';

/**
 * Admin 介入輸入區。
 * Enter 送出，Shift+Enter 換行。
 */
const ChatMessageInput = ({ value, onChange, onSend, sending, disabled }) => {
  const { t } = useLanguage();

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      onSend();
    }
  };

  return (
    <div
      style={{
        padding: 12,
        borderTop: '1px solid #f0f0f0',
        background: '#fff',
        display: 'flex',
        gap: 8,
        alignItems: 'flex-end',
        flexShrink: 0
      }}
    >
      <Input.TextArea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={
          t('workflowMonitor.chatBotInputPlaceholder') ||
          '輸入訊息（Enter 送出，Shift+Enter 換行）'
        }
        autoSize={{ minRows: 1, maxRows: 4 }}
        disabled={disabled || sending}
        style={{ flex: 1 }}
      />
      <Tooltip title={t('workflowMonitor.send') || '發送'}>
        <Button
          type="primary"
          icon={<SendOutlined />}
          onClick={onSend}
          loading={sending}
          disabled={disabled || !value?.trim()}
        >
          {t('workflowMonitor.send') || '發送'}
        </Button>
      </Tooltip>
    </div>
  );
};

export default ChatMessageInput;
